import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import PageBody from "../../components/Shared/PageBody";
import { PopUp } from "../../components/Shared/Info";
import { Button } from "../../components/Shared/Controls";
import Prescriptions from "../../components/MedicalDocuments/Prescriptions";
import { checkAvailabilityOfFeature } from "../../store";
import config from "../../../config.json";
import s from "./style.scss";
import { Box } from "../../components";
const PrescriptionsPage = ({ checkFeature }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [haveChanges, setHaveChanges] = useState(false);
    useEffect(() => {
        !checkFeature("Prescriptions") && navigate("");
    }, []);
    const [youAreSureModal, setYouAreSureModal] = useState(false);
    const toggleYouAreSureModal = () => setYouAreSureModal(!youAreSureModal);
    const backAction = () => {
        !haveChanges
            ? navigate(-1)
            : setYouAreSureModal(true);
    };
    const renderYouAreSureModal = () => {
        return React.createElement(PopUp, { style: s.removeModal, isOpen: youAreSureModal, toggle: toggleYouAreSureModal },
            React.createElement("div", { className: classNames(s.subheading_1, s.mb16) }, t("sureExitWithoutSaving")),
            React.createElement("div", { className: s.actions },
                React.createElement(Button, { style: s.button, text: t("yes"), primary: true, onClick: () => {
                        navigate('/');
                    } }),
                React.createElement(Button, { style: s.button, text: t("no"), onClick: toggleYouAreSureModal })));
    };
    return (React.createElement(Box, { fullWidth: true },
        React.createElement(PageBody, { backAction: backAction, title: t("yourPrescriptions") },
            React.createElement(Prescriptions, { setHaveChanges: setHaveChanges, hasSidebar: true },
                renderYouAreSureModal(),
                config.design_system.showDescriptionOfFeature && React.createElement("div", { className: s.paragraph_2 }, t("addOrDeletePrescriptions"))))));
};
const mapStateToProps = (state) => {
    return {
        checkFeature: (key) => checkAvailabilityOfFeature(state, key),
    };
};
export default connect(mapStateToProps)(PrescriptionsPage);
